// Maps result codes to messages
export const resultCodeMap = {
  "00": "Success",
  "101":
    "Decline - Generally insufficient funds or incorrect card data supplied, for example, expiry date or security code.",
  "102":
    "Referral B - Contact the Authorization Center. Usually treated as a standard decline for Ecommerce systems, the transaction can still be processed using a Manual request once an authorization code is obtained.",
  "103":
    "Referral A - The card has been reported lost or stolen. Usually treated as a standard decline for ecommerce systems.",
  "111":
    "Soft Decline - Indicates that the Issuer requires Strong Customer Authentication (SCA) for a transaction. In order to avoid this outcome, please ensure you enable 3D Secure 2.",
  "120":
    "Return when the settlement amount is 200% or over of the original authorized amount. Only applicable to test accounts domiciled in North America (CA/US).",
  "121":
    "Return when the settlement amount is 25% or less of the original authorized amount. Only applicable to test accounts domiciled in North America (CA/US).",
  "13x":
    "Response from the Payment Declined Response Code (PDRC) service. See our PDRC article.",
  "2xx":
    "Error with bank systems – generally you can tell the customer to try again later. The resolution time depends on the issue.",
  "205": "Comms Error - installment connection error.",
  "3xx":
    "Error with Global Payments systems – generally you can tell the customer to try again later. The resolution time depends on the issue.",
  "5xx":
    "Invalid content in request message. These can be due to a formatting issue or account configuration. Please see the various 5xx examples below.",
  "666":
    "Account deactivated – your Global Payments account has been suspended. Please contact Global Payments.",
  error: "Payment initialization error.",
  // ...add the rest of your codes here
};

export function getDeclineMessage(code) {
  return (
    resultCodeMap[code] ||
    "Unknown error – please try again or contact support."
  );
}
